import * as Promise from 'bluebird';

export const openDatabaseMobile = ({ name }) =>
  new Promise((success, fail) => {
    if (window && window.sqlitePlugin) {
      if (window.device.platform === 'iOS') {
        return window.sqlitePlugin.openDatabase(
          {
            name,
            iosDatabaseLocation: 'Documents',
          },
          success,
          fail
        );
      } else {
        return window.sqlitePlugin.openDatabase(
          {
            name,
            location: 'default',
          },
          success,
          fail
        );
      }
    } else {
      throw new Error('Cordova or sqllitePlugin not installed');
    }
  });
